import { z } from 'zod';
import { overlayKindSchema } from './kinds.js';
/** 스트리머 커스텀 테마 — product 브랜드 토큰과 별개(OverlayTheme ≠ brand). */
export const overlayThemeSchema = z.object({
    primaryColor: z.string(),
    backgroundColor: z.string(),
    fontFamily: z.string().optional(),
});
/** resolve에 실리는 활성 시그니처 요약(최소 필드). User/email 등 신원 필드 금지. */
export const overlayActiveSignatureSchema = z.object({
    id: z.string(),
    name: z.string(),
    imageUrl: z.string().optional(),
    soundUrl: z.string().optional(),
});
/**
 * GET /overlays/:kind/resolve 성공 payload.
 * `userId`·계정 필드는 절대 포함하지 않는다 — 능력 토큰 범위의 렌더 데이터만.
 */
export const overlayResolveSchema = z.object({
    kind: overlayKindSchema,
    theme: overlayThemeSchema.nullable(),
    activeSignature: overlayActiveSignatureSchema.nullable(),
});
/** `overlay-alert.md`의 재생 상태머신 — Redis `stream:{streamId}:overlay` 그대로. */
export const overlayPlayStatusSchema = z.enum(['idle', 'commanded', 'playing', 'paused']);
/** `AlertEvent` 로그 항목 — 재연결(셀프힐링) 시 전체 로그 렌더용. */
export const overlayAlertEventLogSchema = z.object({
    id: z.string(),
    donationType: z.string(),
    unit: z.string(),
    quantity: z.number(),
    /**
     * 후원 시점 닉 스냅샷. 익명·미제공이면 null이다.
     * 표시용 `{donorName}`은 클라이언트가 이 값 또는 폴백 문구를 고른다.
     */
    donorDisplayName: z.string().nullable(),
    /** 수신 시점 스냅샷(JSON 문자열). null이면 매칭 시그니처 없음. */
    resolvedSignature: z.string().nullable(),
    createdAt: z.string(),
});
/** GET /overlays/:kind/state 성공 payload. */
export const overlayStateSchema = z.object({
    currentEventId: z.string().nullable(),
    playStatus: overlayPlayStatusSchema,
    events: z.array(overlayAlertEventLogSchema),
});
export const overlayPlayAckSchema = z.object({
    eventId: z.string().min(1),
});
//# sourceMappingURL=schemas.js.map